import { ActionFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarStateDeprecated } from '../../controller';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import { WidgetComponents, WidgetElements } from '../../../../utilsDeprecated/bi/consts';
import { SetSelectedTime } from '../setSelectedTime/setSelectedTime';
import { FlowElements } from '../../Hooks/useFlow';
import { SetFocusedElement } from '../setFocusedElement/setFocusedElement';
import { QueryAvailabilityResponse } from '@wix/ambassador-availability-calendar/types';
import { Optional, TriggeredByOptions } from '../../../../types/types';
import { CalendarBiLogger } from '../../../../utilsDeprecated/bi/biLoggerFactory';
import { bookingsCalendarClick } from '@wix/bi-logger-wixboost-ugc/v2';
import { isSelectedTimeSlotWithWaitingListIndication } from '../../../../utilsDeprecated/timeSlots/timeSlots';

export type OnTimeSelected = (selectedTime: string) => void;

export function createOnTimeSelectedAction(
  {
    getControllerState,
    context,
  }: ActionFactoryParams<CalendarStateDeprecated, CalendarContext>,
  setSelectedTimeAction: SetSelectedTime,
  setFocusedElement: SetFocusedElement,
): OnTimeSelected {
  return async (selectedTime: string) => {
    const [state] = getControllerState();
    const { biLogger } = context;
    const { availableSlots } = state;

    setSelectedTimeAction(selectedTime, TriggeredByOptions.TIME_SELECTED);

    sendBiEvents(availableSlots, selectedTime, biLogger);

    setFocusedElement(FlowElements.SIDEBAR);
  };
}

const sendBiEvents = (
  availableSlots: Optional<QueryAvailabilityResponse>,
  selectedTime: string,
  biLogger: CalendarBiLogger,
) => {
  const isWaitingListFlow = isSelectedTimeSlotWithWaitingListIndication(
    availableSlots,
    selectedTime,
  );
  const waitListProperty = isWaitingListFlow ? { waitlist: true } : {};

  void biLogger.report(
    bookingsCalendarClick({
      element: WidgetElements.TIME_SLOT,
      component: WidgetComponents.TIME_PICKER,
      properties: JSON.stringify({
        selectedTime,
        ...waitListProperty,
      }),
    }),
  );
};
